/**
 * 科创中国服务协议
 */

import Container from '@/containers';

const aboutRouter = {
    path: '/about',
    component: Container,
    redirect: '/about/agreement',
    name: 'Agreement',
    meta: {
        title: ''
    },
    children: [
        {
            path: 'agreement',
            component: () => import('@/views/about/agreement'),
            name: 'agreement',
            meta: {
                title: '用户协议'
            }
        },
        {
            path: 'privacy',
            component: () => import('@/views/about/privacy'),
            name: 'Privacy',
            meta: {
                title: '隐私政策'
            }
        }
    ]
};

export default aboutRouter;
